var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-button",attrs:{"href":_vm.whatsappLink,"target":"_blank","aria-label":"Fale conosco no WhatsApp"}},[_c('img',{staticClass:"whatsapp-icon",attrs:{"src":"/WhatsApp.svg","alt":"WhatsApp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }